import React from 'react'

import clsx from 'clsx'

const Paragraph = ({ className, ...props }) => <p className={clsx('ContentfulParagraph', className)} {...props} />

export default Paragraph
